// extracted by mini-css-extract-plugin
export default {"orders":"profileOrders_orders__dzTup"};